import React, { useEffect } from "react";
import "./About3.css";

const About3 = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll(".about3 .animate-side");
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="about3" id="about3">
      <h1 className="about-title animate-side slide-left row-0">
        <p className="margin-0">Benefits of using</p>
        <p id="p1" className="margin-0">Our Services</p>
      </h1>

      <div className="content-1">
        <div className="content-2">
          <p className="animate-side slide-right row-1">
            Partnering with Dataharbor gives your business a competitive edge 
            by streamlining operations, boosting customer engagement, and reducing 
            overhead costs with scalable digital solutions.
          </p>

          <p className="animate-side slide-left row-2">
            From seamless POS and ERP integrations to custom mobile apps and web platforms, 
            our services are engineered to grow effortlessly alongside your enterprise.
          </p>

          <div className="animate-side slide-right row-3">
            <label>
              <a href="/advantage">DISCOVER ALL BENEFITS</a>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About3;